<template>
  <v-list flat>
    <v-list-item-group v-for="(item, i) in searchList" :key="i">
      <v-row class="ma-0" @click="$emit('selectItem', item.postId)">
        <v-col cols="12" class="pt-0 px-6 pb-2">
          <v-card elevation="0" class="board-guide text-truncate"
            ><v-icon size="24" class="mr-1" color="#087ef7"
              >mdi-bell-outline</v-icon
            >{{ item.title }}</v-card
          >
        </v-col>
      </v-row>
    </v-list-item-group>
  </v-list>
</template>

<script>
/* 중요게시글리스트 컴포넌트 */
export default {
  props: {
    searchList: { type: [] },
  },
};
</script>

<style></style>
